import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderCrudViewComponent } from './crud-view.component';
import { RappiderEditFormModule } from '../edit-form/edit-form.module';
import { RappiderListGridModule } from '../list-grid/list-grid.module';
import { FormsModule } from '@angular/forms';
import { RappiderTitleToolbarModule } from '../title-toolbar/title-toolbar.module';
import { RappiderCardCcsModule } from '../card-ccs/card-ccs.module';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { RappiderInputGroupModule } from '../input-group/input-group.module';
import { RappiderCrudFieldsDisplayModule } from '../crud-fields-display/crud-fields-display.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { RappiderGridBuilderModule } from '../grid-builder/grid-builder.module';
import { RappiderCardBuilderModule } from '../card-builder/card-builder.module';
import { DataDetailViewBuilderModule } from '../data-detail-view-builder/data-detail-view-builder.module';
import { JoyrideModule } from 'ngx-joyride';
import { RappiderAlertModule } from '../alert/alert.module';
import { RappiderButtonModule } from '../button/button.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';


@NgModule({
  declarations: [
    RappiderCrudViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderTitleToolbarModule,
    RappiderListGridModule,
    RappiderEditFormModule,
    RappiderEditFormModule,
    RappiderCardCcsModule,
    RappiderInputGroupModule,
    RappiderCrudFieldsDisplayModule,
    NzEmptyModule,
    NzTabsModule,
    RappiderGridBuilderModule,
    RappiderCardBuilderModule,
    DataDetailViewBuilderModule,
    JoyrideModule.forChild(),
    RappiderAlertModule,
    RappiderButtonModule,
    NzButtonModule,
    NzToolTipModule
  ],
  exports: [
    RappiderCrudViewComponent
  ]
})
export class RappiderCrudViewModule { }
